import type { PortfolioTaskQuestionAnswerResource } from "api/generated";
import type { QuestionAnswer } from "portfolio/types";

export const questionAnswerFromDto = (
  questionAnswer: PortfolioTaskQuestionAnswerResource,
): QuestionAnswer => ({
  id: questionAnswer.id,
  question: questionAnswer.question,
  type: questionAnswer.type,
  order: questionAnswer.order,
  required: questionAnswer.required,
  answer: questionAnswer.answer,
  options: questionAnswer.options,
});

export const questionAnswerToDto = (
  questionAnswer: QuestionAnswer,
): PortfolioTaskQuestionAnswerResource => ({
  id: questionAnswer.id,
  question: questionAnswer.question,
  type: questionAnswer.type,
  order: questionAnswer.order,
  required: questionAnswer.required,
  answer: questionAnswer.answer,
  options: questionAnswer.options,
});
